import { ReactNode, useCallback, useEffect } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { trackEvent, TrackEvents } from '@client/utils/analytics';
import {
  BackButton,
  ConnectContainerWrapper,
  StyledHeader,
  Title,
} from './connect-container.style';

export type Props = {
  previous?: () => void;
  title: string;
  /** Figma left-aligns only the entry screen's title; every other screen centers it. */
  flushLeftTitle?: boolean;
  children: ReactNode;
  testId?: string;
};

export const ConnectContainer = ({
  previous,
  title,
  flushLeftTitle = false,
  children,
  testId,
}: Props): JSX.Element => {
  const { t } = useTranslation('connect', { keyPrefix: 'components.connectContainer' });

  const handlePrevious = useCallback(() => {
    if (previous) {
      trackEvent(TrackEvents.PREVIOUS_CLICKED, { currentScreen: title });
      previous();
    }
  }, [previous, title]);

  useEffect(() => {
    trackEvent(`Screen viewed - ${title}`);
  }, [title]);

  return (
    <ConnectContainerWrapper data-testid={testId}>
      <StyledHeader $hasBackButton={!!previous}>
        <Title $flushLeft={flushLeftTitle}>{title}</Title>
        {!!previous && (
          <BackButton
            variant="ghost"
            size="sm"
            onClick={handlePrevious}
            aria-label={t('backButton')}
          >
            <ChevronLeft />
          </BackButton>
        )}
      </StyledHeader>
      {children}
    </ConnectContainerWrapper>
  );
};
